/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class AnchorMenu extends HTMLElement {
  constructor() {
    super();
    this.activeSlide = null;
    this.handleScroll = this.updateMenuTop.bind(this);
    this.handleResize = this.updateMenuTop.bind(this);
  }
  connectedCallback() {
    this.anchorMenu = this.querySelector('[data-anchor-menu]');
    if (!this.anchorMenu) return;
    this.swiperWrapper = this.anchorMenu.querySelector('.swiper-wrapper');
    this.swiperEl = this.anchorMenu.querySelector('swiper-slider');
    if (!this.swiperWrapper || !this.swiperEl) return;
    this.headings = Array.from(document.querySelectorAll('.rich-text__heading.h2, .title')).filter(heading => /^\d/.test(heading.textContent.trim()));
    if (!this.headings.length) return;
    this.injectSlides();
    this.initScrollSpy();
    this.updateSwiper();
    window.addEventListener('load', () => this.updateMenuTop());
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    this.observeHeaderChanges();
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
  }
  getHeaderHeight() {
    const header = document.querySelector('.shopify-section-header');
    const announcement = document.querySelector('.shopify-section-announcement-bar');
    if (!header) return 0;
    const isSticky = header.classList.contains('shopify-section-header-sticky');
    const isHidden = header.classList.contains('shopify-section-header-hidden');
    if (!isSticky || isHidden) {
      return 0;
    }
    let totalHeight = header.offsetHeight;
    if (announcement && announcement.offsetParent !== null) {
      totalHeight += announcement.offsetHeight;
    }
    return totalHeight;
  }
  updateMenuTop() {
    const container = document.querySelector('.menu-anchor');
    if (!container) return;
    const height = this.getHeaderHeight();
    container.style.setProperty('--header-height', `${Math.max(height, 1) - 1}px`);
  }
  observeHeaderChanges() {
    const header = document.querySelector('.shopify-section-header');
    if (!header) return;
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMenuTop();
      });
      this.resizeObserver.observe(header);
    }
    this.mutationObserver = new MutationObserver(() => {
      this.updateMenuTop();
    });
    this.mutationObserver.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  injectSlides() {
    this.headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `anchor-section-${index + 1}`;
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.textContent = heading.textContent.trim();
      slide.setAttribute('role', 'button');
      slide.setAttribute('tabindex', '0');
      const scrollToTarget = () => {
        const offset = this.getHeaderHeight();
        const y = heading.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
        this.setActiveSlide(slide);
      };
      slide.addEventListener('click', scrollToTarget);
      slide.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToTarget();
        }
      });
      this.swiperWrapper.appendChild(slide);
    });
  }
  setActiveSlide(slide) {
    if (this.activeSlide) {
      this.activeSlide.classList.remove('active');
    }
    slide.classList.add('active');
    this.activeSlide = slide;
  }
  initScrollSpy() {
    const bottomOffset = 100;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const heading = entry.target;
          const index = this.headings.indexOf(heading);
          const slide = this.swiperWrapper.children[index];
          if (slide) this.setActiveSlide(slide);
        }
      });
    }, {
      rootMargin: `0px 0px -${bottomOffset}px 0px`,
      threshold: 0
    });
    this.headings.forEach(h => observer.observe(h));
  }
  updateSwiper() {
    if (this.swiperEl?.swiper) {
      this.swiperEl.swiper.update();
    } else {
      this.swiperEl.addEventListener('swiper:init', () => this.swiperEl.swiper.update(), {
        once: true
      });
    }
  }
}
customElements.define('anchor-menu', AnchorMenu);
/******/ })()
;